import React from 'react';
import './Banner.css';

export default function Banner(props) {
  return(
    <section className="banner-logo" role="region">
      <h1 className="logo">
        <span className="logo-d">d</span>
        <span className="logo-e">e</span>
        <span className="logo-v">v</span>
        <span className="logo-S">S</span>
        <span className="logo-n">n</span>
        <span className="logo-i">i</span>
        <span className="logo-p">p</span>
        <span className="logo-s">s</span>
      </h1>
    </section>
  );
};


// WEBPACK FOOTER //
// ./src/components/Banner/Banner.js